<template>
    <div>
        <section class="section-grey py-3 my-3">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-3 text-md-right order-md-2 mb-4 mb-md-0">
                        <button @click="invertDate()" class="btn btn-link">Sorteer op datum
                            <span v-if="order === 'desc'"><i class="fas fa-caret-up"></i></span>
                            <span v-else><i class="fas fa-caret-down"></i></span>
                        </button>
                    </div>
                    <div class="col order-md-1">
                        <div class="d-flex align-items-md-center">
                            <div>
                                <span class="d-flex small mr-3 filter"><strong>Filter op:</strong></span>
                            </div>
                            <div>
                                <button v-for="(filter, index) in filters" :key="filter.name" :class="filter.active ? 'active' : ''"
                                        @click="applyFilter(1, index, $event.currentTarget)" class="btn btn-outline-secondary btn-sm m-2">{{ filter.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
            <alert v-for="(item, index) in items" v-if="item.active && item.shown" :key="item.id" :index="index" :rawItem="item" :id="'alert-' + item.id">

            </alert>
            <div class="row">

            </div>
            <div class="row justify-content-center text-center">
                <div class="col-8">
                    <transition name="fade">
                        <button v-if="hasMore" type="button" class="btn btn-outline-primary my-4" @click="loadMore()">
                            <span v-if="processing"><spinner :color="'#fdccaf'"></spinner></span>
                            <span v-else>Toon meer</span>
                        </button>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alert from '../components/Alert';
import Spinner from 'vue-spinner-component/src/Spinner';

export default {

    components: {
        Alert,
        Spinner,
    },
    data() {
        return {
            hasMore: false,
            items: [],
            page: 1,
            order: 'desc',
            processing: false,
            filters: [],
            perPage: 10,
            position: null
        }
    },
    created (){
        let that = this;
        this.axios.get('/alert-items')
            .then(function (response) {
                that.items = response.data
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
                // Create filter
                that.items.forEach(function (item) {
                    that.filters.push({
                        name: item.onderwerp,
                        active: false,
                    });
                });

                that.filters = _.uniqBy(that.filters, 'name');

                // Apply filter
                let highestPage = that.$session.get('alerts-index-page');
                let timeDiff = Date.now() - that.$session.get('alerts-index-page-time');

                if (highestPage >= 2 && timeDiff < (3 * 60 * 1000)) {
                    that.applyFilter(highestPage, -1)

                    that.order = that.$session.get('alerts-index-page-order');
                    if (that.order !== 'desc') {
                        that.items.reverse();
                    }
                } else {
                    that.applyFilter(1, -1);
                }

            })
    },
    updated: function () {
        this.$nextTick(function () {
            if (window.location.hash && !this.position) {
                let hash = window.location.hash.replace('#', '');
                this.scrollTo(hash);
            }
        })
    },
    methods: {
        scrollTo(id) {
            let element = document.getElementById(id);
            if(element) {
                element.scrollIntoView();
                this.position = id;
            }
        },
        invertDate() {
            this.order = this.order === 'desc' ? 'asc' : 'desc';
            this.$session.set('alerts-index-page-order', this.order);
            this.items.reverse();
        },
        applyFilter(page, index, el) {
            this.page = page;

            // Blur button
            if (el) {
                el.blur();
            }

            // Modify selected button, and clear filters from session storage
            if (index > -1) {
                this.filters[index].active = !this.filters[index].active;
                this.$session.remove('alerts-active-filters');
            }

            // Reset filters from session storage if available
            let sessionFilters = this.$session.get('alerts-active-filters');
            if (sessionFilters) {
                let that = this;
                sessionFilters.forEach(function (filter) {
                    let i = _.findIndex(that.filters, {'name': filter.name});

                    that.filters[i].active = true;
                });
            }

            // Re-apply filters
            let activeFilters = _.filter(this.filters, {'active': true});
            let toBeShown = this.page * this.perPage;
            let wantsToShow = 0;
            let shownCount = 0;

            this.items.forEach(function (item) {

                item.shown = false;

                if (activeFilters.length === 0) {
                    // Allemaal tonen wanneer geen filter
                    item.active = true;
                } else {
                    if (_.some(activeFilters, {'name': item.onderwerp })) {
                        item.active = true;
                    } else {
                        item.active = false;
                    }
                }

                if (item.active) {
                    wantsToShow++;
                }

                if (item.active && (shownCount < toBeShown)) {
                    item.shown = true;
                    shownCount++;
                }
            });

            this.hasMore = wantsToShow > shownCount;

            // set in session storage
            this.$session.set('alerts-index-page', this.page);
            this.$session.set('alerts-index-page-time', Date.now());
            this.$session.set('alerts-active-filters', activeFilters);
        },
        loadMore() {
            this.applyFilter(++this.page);
        },
    }

}
</script>
